import FormFw from '../../../framework/form/FormFw';
import { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import { BasePage } from '../../../framework/pages/BasePage';
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { EnvConstants } from '../../../EnvConstants';
import { UserUtil } from '../../../util/UserUtil';
import { getValidationGenerarCadenaModal } from './getValidationGenerarCadenaModal';
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { MessageUtil } from '../../../util/MessageUtil';

export class GenerarCadenaModal extends BasePage {
  constructor(props) {
    super(props);
    this.generarCadenaModal = {};
  };

  createPageProperties = (pageApi) => {
    return {
      validation: getValidationGenerarCadenaModal,
    };
  }

  renderPage(pageApi) {
    const barButtonsave_cadena = {
      fields: [
        { ...BUTTON_DEFAULT.RETURN, label: "Retornar", onClick: () => pageApi.hideThisModal() },
        {
          ...BUTTON_DEFAULT.NEW, label: 'Generar', onClick: () => {
            if (!this.generarCadenaModal.tipo_cadena) {
              MessageUtil("warning", "Tipo de Cadena es requerido.", "")
              return;
            }

            const dta = { 
              tipo_cadena: this.generarCadenaModal.tipo_cadena, 
              cadena: this.generarCadenaModal.cadena,
              id_ss: pageApi.name.id_ss,
            }

            sessionStorage.setItem("storage_cadena", JSON.stringify(dta));
            this.props.history.push(`/solicitudes-asignadas/solicitudes-asignadas/cadenas/0`);

            // LoadUtil.loadByQueryId({
            //   url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
            //   queryId: 877,
            //   reqParams: {
            //     params: {
            //       id_ss: pageApi.name.id_ss,
            //       id_tipo_cadena: this.generarCadenaModal.tipo_cadena,
            //       id_user: UserUtil.getUserId(),
            //     },
            //   },
            //   fnOk: (resp) => {
            //     if (resp.dataObject) {                  
            //       MessageUtil("success", resp.message, "")

            //       if (resp.dataObject.id_cadena) {
            //         this.props.history.push(`/solicitudes-asignadas/solicitudes-asignadas/cadenas/${resp.dataObject.id_cadena}`);
            //       }
            //     }
            //   },
            // });
          }
        }
      ]
    }

    const formConfig = {
      layout: "vertical",
      fields: [
        {
          type: "select", name: "tipo_cadena", label: "Seleccione Tipo de Cadena:", column: 12, load: { queryId: 873 }, search: true, onChange: (value, row, val) => {
            const data = val.getFieldApi('tipo_cadena').dataList || [];
            const cadena = data.find(el => el.value === parseInt(value))
            this.generarCadenaModal = {
              tipo_cadena: value,
              cadena: cadena?.cadena
            }
          }, required: true
        }
      ],
      bar: barButtonsave_cadena
    }

    return (
      <FormFw
        name="generarCadenaModal"
        layout="vertical"
        getParentApi={pageApi.getApi}
        config={formConfig}
      />
    )

  }

}

export default withRouter(GenerarCadenaModal);